import * as React from "react";
import type { SVGProps } from "react";
const SvgKtvLineIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="ktv_line_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M924.33 309.461a42.667 42.667 0 0 1 3.542 60.203l-170.667 192A42.667 42.667 0 0 1 725.333 576H593.664L414.165 755.499a42.667 42.667 0 0 1-62.933-2.859l-76.8-92.117-116.267 116.309a42.667 42.667 0 0 1-60.33-60.33l149.333-149.334a42.667 42.667 0 0 1 62.933 2.859l76.8 92.117 158.934-158.976A42.667 42.667 0 0 1 576 490.667h130.133l157.995-177.664a42.667 42.667 0 0 1 60.203-3.542z"
    />
  </svg>
);
export default SvgKtvLineIcon;
